export default "/build/images/amex.79c8e7b5.png";